<div class="page-wrapper">
  <super-sidebar [langLinks]="langLinks" (langChg)="receive_langChg($event)" [display]="true" [isAdmin]="isAdmin"
    [user]="user" [name]="name"
    applicationTitle="{{ appConfig?.clientType !== null && appConfig?.clientType !== 'inforius' ? '' : 'iDelibe' }}"
    [logout]="logout" [navLinks]="navLinks" [theme]="themeName" [accountLinks]="accountLinks" [hideAppsLinks]="true"
    [settingsLinks]="settingsLinks" [logoApp]="image" [logoWebsite]="webSite" [hideNotif]="true"
    [assistanceRoute]="'/private/assistance'" [setSmallSidebar]="hasSmallSidebar"
    [entityName]="globalsObject.configApp?.clientName"></super-sidebar>
  <main class="page-content h-100">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col-12 main__content">
          @if(areGlobalOptionsReady()) {
          <router-outlet></router-outlet>

          }@else {
          <div style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      height: 100%;
                      width: 100%;">

            <i-loader></i-loader>
          </div>
          }
        </div>
      </div>
    </div>
  </main>
</div>